<template>
    <v-dialog v-model="ShowDialog" max-width="900" persistent>
        <v-card class="rounded-xl">
            <v-card-title class="headline primary gradient-primary white--text">
                <div class="header-left">
                    <v-avatar size="32" color="white" class="mr-4">
                        <v-icon color="dark" size="24">mdi-upload</v-icon>
                    </v-avatar>
                    <span>Cargar Documentos</span>
                </div>
                <v-spacer></v-spacer>
                <v-btn icon @click="ShowDialog = false" color="white">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-col>
                <s-toolbar color="" label=" " :remove="true" save @save="save()" @removed="removeItem()" />
                <v-divider></v-divider>

                <v-col style="padding: 0px">
                    <v-data-table mobile-breakpoint="0" item-key="item" dense :items="files" v-model="selected"
                        :height="!isEditable ? '290' : $vuetify.breakpoint.xs ? 'auto' : '272'" :headers="headers"
                        class="elevation-0" :items-per-page="-1" @click:row="rowClick" :sort-by="['SpcType']"
                        :sort-desc="[false]" ref="crudfiles">

                        <template v-slot:item.SpcFilename="{ item }">
                            <div class="text-truncate text-start" style="max-width: 120px;">
                                {{ item.SpcFilename }}
                            </div>
                        </template>

                        <template v-slot:item.SpcOptions="{ item }">
                            <div v-if="item.SpcFilename" class="text-center" style="max-width: 140px;">
                                <v-tooltip bottom="">
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon color="success" @click="download(item.SpcFilename)"
                                            title="Descargar">
                                            <v-icon>mdi-download</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar</span>
                                </v-tooltip>
                            </div>
                            <div v-else class="text-center file-upload-area" style="min-width: 160px;">
                                <v-file-input label="Seleccionar Archivo" :id="`fileinput_${item.SpcType}`" counter
                                    v-model="files[item.SpcType - 1].attach" show-size small-chips truncate-length="10"
                                    hide-details style="padding: 0px;" :rules="[rulesFile]" />
                            </div>
                        </template>

                        <template v-slot:item.SpcOthers="{ item }">
                            <div style="max-width: 20px;">
                                <v-switch style="transform: scale(0.6); margin: 0; padding: 0;" v-model="item.SpcOthers"
                                    color="primary" inset hide-details></v-switch>
                            </div>
                        </template>

                        <template v-slot:item.SpcStartDate="{ item }">
                            <div v-if="item.SpcOthers && item.SpcFilename || item.SpcOthers && item.attach" class="d-flex flex-row" style="gap:12px">
                                <s-date label="" v-model="item.SpcStartDate" dense hide-details></s-date>
                            </div>
                        </template>

                        <template v-slot:item.SpcExpireDate="{ item }">
                            <div v-if="item.SpcOthers && item.SpcFilename || item.SpcOthers && item.attach" class="d-flex flex-row" style="gap:12px">
                                <s-date label="" v-model="item.SpcExpireDate" dense hide-details></s-date>
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
            </v-col>
        </v-card>
    </v-dialog>
</template>

<script>
import _SpcDocumentService from "@/services/SupplyChain/Transport/SpcDocumentService.js";
import _sGeneral from "@/services/HelperService.js";
import _GenUploadFiles from "../../../services/General/GenUploadFiles";

export default {
    components: {},
    props: {
        SpcID: {
            type: Number,
            default: 0
        },
        dialogFiles: {
            type: Boolean,
            default: false
        },
        typeFiles: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        filter: {
            SpcID: null
        },
        ShowDialog: false,
        selected: [],
        files: [],
        headers: [
            { text: "ID", value: "item", width: 30 },
            { text: "Tipo Documento", value: "SpcTypeName", align: "left", width: 120 },
            { text: "Nombre", value: "SpcFilename", align: "center", width: 100 },
            { text: "File", value: "SpcOptions", align: "center", width: 100 },
            { text: "Expira", value: "SpcOthers", align: "center", width: 20 },
            { text: "Fecha Inicio", value: "SpcStartDate", align: "center", width: 120 },
            { text: "Fecha Vencimiento", value: "SpcExpireDate", align: "center", width: 120 },
        ],
        files: [],
        Attach: null,
        formats_accepted: ["image/jpeg", "image/jpg", "image/png", "application/pdf"],
        max_size: 3000000,
        config: {
            model: {
                SpcdID: "ID",
                SpcFilename: "string",
                SpcID: "int",
                SpcOptions: ""
            },
            service: _SpcDocumentService,
        },
        SpcDocument: {
            SpcdID: 0,
            SpcID: 0,
            SpcFilename: null,
            SecStatus: 1,
            UsrCreateID: 0,
        }
    }),
    computed: {
        isEditable() {
            // return this.advanceProducer.AdpID > 0;
            return true;
        },
    },
    watch: {
        dialogFiles(value) {
            this.ShowDialog = value
        },
        ShowDialog(value) {
            this.$emit('update:dialogFiles', value)
        },
        SpcID(value) {
            this.$nextTick(() => {
                this.filter = { SpcID: value }
                this.list(value);
                // this.$refs.crudfiles.refresh();
            });
        },
    },
    mounted() {
        this.filter = { SpcID: this.SpcID }
        this.list(this.SpcID);
    },
    methods: {
        rowClick: function (item) {
            this.selected = [item];
        },
        validateFile(file) {
            // this.$set(this.files[index], 'attach', null)
            if (!file) {
                return false;
            }
            if (file == null || file == undefined || !file) {
                return false
            }
            if (!this.formats_accepted.includes(file.type)) {
                return false;
            }
            if (file.size > this.max_size) {
                return false;
            }
            return true;
        },
        rulesFile(file) {
            if (!file || file == null || file == undefined || !file) {
                return true;
            }
            if (!this.formats_accepted.includes(file.type)) {
                this.$fun.alert(`Formato de archivo no permitido: ${file.type}`, "warning");
                return `Formato de archivo no permitido: ${file.type}`;
            }
            if (file.size > this.max_size) {
                this.$fun.alert(`Tamaño de archivo excede el límite permitido: ${this.max_size}`);
                return `Tamaño de archivo excede el límite permitido: ${this.max_size}`;
            }
            return true;
        },
        async save() {
            try {
                const values = this.files.filter(file => {
                    const isValid = this.validateFile(file.attach);
                    if (isValid) return file;
                    // return {...attach}
                });

                if (values.length > 0) {
                    const UsrCreateID = this.$fun.getUserID();
                    values.forEach(async (file, index) => {

                        const result = await _GenUploadFiles.upload(file.attach, `Spc${this.filter.SpcID}_${Date.now()}`, 'PathDocumentCarrier', true);

                        if (result.status == 200) {
                            const SpcDocument = {
                                SpcdID: 0,
                                SpcType: file.SpcType,
                                SpcFilename: result.data.fileName,
                                SpcID: this.filter.SpcID,
                                UsrCreateID: UsrCreateID,
                                SecStatus: 1,
                            }

                            const response = await _SpcDocumentService.save(SpcDocument, UsrCreateID);
                            if (response.status == 200) {
                                this.list(this.filter.SpcID);
                                if (index == values.length - 1) {
                                    this.$fun.alert("Se ha guardado correctamente", "success");
                                }
                                console.log('Guardado correctamente');
                            } else {
                                this.$fun.alert("Error al registrar archivo", "warning");
                            }
                        } else {
                            this.$fun.alert("Error al subir archivo en directorio con parámetro de ruta " + PathDocumentCarrier, "warning");
                        }
                    })
                    // this.$refs.crudfiles.refresh();
                } else {
                    this.$fun.alert("No se han encontrado nuevos cambios", "info");
                }
            } catch (error) {
                this.$fun.alert("Error al subir archivo", "warning");
                console.error("Error al subir archivo :", error);
            }
        },

        async list(SpcID) {
            const response = await _SpcDocumentService.list(SpcID, this.$fun.getUserID());
            if (response.status == 200) {
                const data = response.data;
                if (data.length > 0 && this.typeFiles.length > 0) {
                    this.files = this.typeFiles.map(file => {
                        const item = data.find(x => x.SpcType == file.SpcType)
                        return {
                            ...file,
                            SpcdID: item ? item.SpcdID : 0,
                            SpcID: item ? item.SpcID : 0,
                            SpcFilename: item ? item.SpcFilename : null,
                            SpcOthers: false,
                            SpcStartDate: null,
                            SpcExpireDate: null
                        }
                    })
                } else {
                    this.files = this.typeFiles;
                }
            }
        },

        download(fileName) {
            if (fileName) {
                _GenUploadFiles.getFile("PathDocumentCarrier", `${fileName}`)
                    .then(resp => console.log('downloaded : ', resp))
                    .catch(error => console.error("Error al obtener imagen:", error));
            }
        },
        cleanFields() {
            this.Attach = null;
        },

        async removeItem() {

            if (this.selected.length == 0) return;
            let itemRemove = this.selected[0];

            if (itemRemove.SpcdID > 0) {
                const result = await this.$fun.alert("Seguro de Eliminar Registro?", "question");
                if (result.value) {
                    const UsrCreateID = this.$fun.getUserID();
                    const SpcDocument = {
                        SpcdID: itemRemove.SpcdID,
                        SpcType: itemRemove.SpcType,
                        SpcFilename: itemRemove.SpcFilename,
                        SpcID: itemRemove.SpcID,
                        UsrCreateID: UsrCreateID,
                        SecStatus: 0,
                    }

                    const response = await _SpcDocumentService.save(SpcDocument, UsrCreateID);

                    if (response.status == 200) {
                        this.selected = [];
                        this.list(this.filter.SpcID);
                        this.$fun.alert("Eliminado correctamente.", "success");
                    }
                }
            }
        }
    }
};
</script>

<style scoped>
.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.gradient-primary {
    background: linear-gradient(135deg, #a4a4a4 29%, #322d38 100%);
}

.header-left {
    display: flex;
    align-items: center;
}

.header-right {
    display: flex;
    justify-items: center;
    align-items: center !important;
    min-width: 300px;
}
</style>
